import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {Observable} from 'rxjs';
import {environment} from '@env';
import {
  Success,
  DateRange,
  EventInterface,
  CompletedEvents,
  RowLocationsList,
  LocationInterface,
  LocationStatistics,
  LocationsListStatistics, UserLocations, LocationType, PresigneFileData
} from '@core/models';

@Injectable({
  providedIn: 'root'
})
export class LocationsService {

  constructor(
    private http: HttpClient,
  ) {
  }

  public getUserLocations(offset: number, limit: number): Observable<UserLocations> {
    return this.http.get<UserLocations>(`${environment.apiUrl}locations/locations-listed?offset=${offset}&limit=${limit}`);
  }

  public getLocationStats(data: DateRange): Observable<LocationsListStatistics> {
    return this.http.post<LocationsListStatistics>(`${environment.apiUrl}locations/stats`, data);
  }

  public getLocationById(id: string): Observable<LocationInterface> {
    return this.http.get<LocationInterface>(`${environment.apiUrl}locations/${id}`);
  }

  public getLocationStatsById(id: string): Observable<LocationStatistics> {
    return this.http.get<LocationStatistics>(`${environment.apiUrl}locations/stats/${id}`);
  }

  public getLocationTypes(): Observable<LocationType[]> {
    return this.http.get<LocationType[]>(`${environment.apiUrl}locations/types`);
  }

  public saveLocation(id: string, data: FormData): Observable<LocationInterface> {
    if (id) {
      return this.http.patch<LocationInterface>(`${environment.apiUrl}locations/${id}`, data);
    } else {
      return this.http.post<LocationInterface>(`${environment.apiUrl}locations`, data);
    }
  }

  public getCompletedEventsByRange(id: string, range: DateRange, offset: number = 0, limit: number = 10): Observable<CompletedEvents> {
    return this.http.post<CompletedEvents>(`${environment.apiUrl}locations/completed-events/${id}?offset=${offset}&limit=${limit}`, range);
  }

  public getUpcomingEvents(id: string, offset: number = 0, limit: number = 10): Observable<EventInterface[]> {
    return this.http.get<EventInterface[]>(`${environment.apiUrl}locations/upcoming-events/${id}?offset=${offset}&limit=${limit}`);
  }

  public archiveLocation(id: string, offset: number = 0, limit: number = 10): Observable<Success> {
    return this.http.patch<Success>(`${environment.apiUrl}locations/archive/${id}`, []);
  }

  public getArchivedLocations(): Observable<RowLocationsList[]> {
    return this.http.get<RowLocationsList[]>(`${environment.apiUrl}locations/user-archived`);
  }

  public makeLocationsActive(data: { ids: string[] }): Observable<RowLocationsList[]> {
    return this.http.patch<RowLocationsList[]>(`${environment.apiUrl}locations/active`, data);
  }

  public getPresignedUrl(fileData: PresigneFileData): Observable<string> {
    return this.http.post(`${environment.apiUrl}aws/gen-presigned-url`, fileData, {responseType: 'text'});
  }

  public uploadFileToAWS(url, fileData: any): Observable<unknown> {
    return this.http.put<unknown>(url, fileData);
  }

  public uploadPdf(data:{location_id: string, pdf_name: string}): Observable<Pick<LocationInterface, 'location_info'>> {
    return this.http.post<Pick<LocationInterface, 'location_info'>>(`${environment.apiUrl}locations/upload-pdf`, data);
  }
}

